import { useAudienceCatalog } from '@/hooks/useAudienceCatalog';
import { useTranslation } from '@/hooks/useTranslation';
import { UserAudience } from '@/services/audienceService';
import AudienceGroupPicker from './AudienceGroupPicker';

export default function UserAudienceFields({ value, onChange, disabled }: { value: UserAudience; onChange: (value: UserAudience) => void; disabled?: boolean }) {
  const { t: { audience: copy } } = useTranslation();
  const query = useAudienceCatalog();
  if (query.isPending) return <p>{copy.loading}</p>;
  if (!query.data) return <p role="alert">{copy.loadError}</p>;
  const assignment = value.assignments?.find(a => !a.deviceId) ?? value.assignments?.[0];
  return <fieldset disabled={disabled} className="col-span-full space-y-4 border-t border-gray-200 pt-4">
    <h3 className="font-semibold text-gray-900">{copy.serviceGroup}</h3>
    <AudienceGroupPicker nodes={query.data.nodes} label={copy.serviceGroup} hideLabel singleSelect pillTrigger selected={assignment?.nodeId ? [assignment.nodeId] : []}
      onChange={ids => onChange({ assignments: ids.length ? [{ nodeId: ids[0] }] : [] })} />
  </fieldset>;
}
